import { CASHBOX_LIST, CASHWARRANT_STATUS, CASHWARRANT_LIST_STOCK, CASHWARRANT_LIST_ORG } from './actionTypes';

const defaultState = {
  cashBoxList: [],
  cashBoxListStock: [],
  cashBoxListOrg: [],
  status: 0,
};

export function cashWarrant(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case CASHBOX_LIST:
      return {
        ...state,
        cashBoxList: payload,
      };

    case CASHWARRANT_STATUS:
      return {
        ...state,
        status: payload,
      };

    case CASHWARRANT_LIST_STOCK:
      return {
        ...state,
        cashBoxListStock: payload,
      };

    case CASHWARRANT_LIST_ORG:
      return {
        ...state,
        cashBoxListOrg: payload,
      };

    default:
      return state;
  }
}
